// ============================================================
// tabId.ts — (D12 live updates) this browser tab's id.
//
// Sent on every API call as the `X-Casevo-Tab` header (api/casevoApi). The
// server stamps it on the live messages a write causes (`originTab`); the
// tab that made the change ignores its own echo — it already shows it.
//
// One id per page load, kept in memory on purpose: sessionStorage is COPIED
// when a tab is duplicated, so two tabs would share an id and each would
// ignore the other's changes. A reload getting a new id is harmless.
// 22 chars of [A-Za-z0-9_-] (the server accepts 6–64 of those).
// ============================================================
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-'

const makeId = (): string => {
  const bytes = new Uint8Array(22)
  try {
    const c = (typeof window !== 'undefined' ? window.crypto : undefined) as Crypto | undefined
    if (c?.getRandomValues) c.getRandomValues(bytes)
    else throw new Error('no crypto')
  } catch {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
  }
  let out = ''
  for (let i = 0; i < bytes.length; i++) out += ALPHABET[bytes[i] & 63]
  return out
}

export const TAB_ID: string = makeId()
export const getTabId = (): string => TAB_ID
